


<div class="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
  <header class="mb-auto">
    <div>
      <div class="container">
        <a routerLink="/" class="d-flex mx-auto align-items-center text-center  text-white text-decoration-none">
          <img src="/assets/img/medilinkLogo.svg" class="w-25 h-25 text-center" alt="">
        </a>
      </div>
      <h3 *ngIf="nombreProveedor" class=" mb-0">Sube tu factura correspondiente a la orden de compra #{{codigoOrden}}</h3>
      <nav class="nav nav-masthead justify-content-center float-md-end">
        <a class="nav-link fw-bold py-1 px-0 active" aria-current="page" href="#"></a>
      </nav>
    </div>
  </header>

  <main class="px-3">
    <div class="container">

      <h1 *ngIf="nombreProveedor">¡Hola, <span class="fw-bolder">{{ nombreProveedor }}!</span> </h1>
      <p *ngIf="nombreProveedor; else elseBlock" class="lead fw-bold"> Estamos encantados de presentarte nuestra nueva herramienta para subir tus facturas de forma rápida y segura.</p>

      <ng-template #elseBlock>
        <h1 >¡Al parecer ha ocurrido un error! :c </h1>
        <p  class="lead">
          Parece que el enlace al que intentas acceder no es válido o los parámetros en la URL están incorrectos.
          Por favor, revisa que el enlace sea el correcto o ponte en contacto con nuestro equipo de soporte para ayudarte a encontrar lo que necesitas.
        </p>
      </ng-template>
    </div>

    <div class="container " *ngIf="nombreProveedor">
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="formFileXML" class="form-label">Archivo XML <i class="bi bi-filetype-xml"></i></label>
            <input #inputXML [disabled]="isDisabled" class="form-control" type="file" id="formFileXML" accept=".xml" (change)="capturarArchivo($event, 'xml', codigoOrden)" >
          </div>
        <!--  <p class="lead">
            <a href="#" class="btn btn-lg btn-light  fw-normal fs-6  border-white bg-white">Subir XML <i class="bi bi-filetype-xml"></i></a>
          </p>-->
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label for="formFilePDF" class="form-label">Archivo PDF <i class="bi bi-filetype-pdf"></i></label>
            <input #inputPDF [disabled]="isDisabled" class="form-control" type="file" id="formFilePDF" accept=".pdf" (change)="capturarArchivo($event, 'pdf', codigoOrden)" >
          </div>

        </div>

        <div class="row-12">
          <p class="lead">
            <button [disabled]="isDisabled" (click)="sendFiles()" class="btn btn-lg btn-outline-secondary  fw-normal fs-6  ">Subir Archivos <i
              class="bi bi-cloud-arrow-up"></i></button>

          </p>
        </div>
      </div>
    </div>
  </main>


  <footer class="mt-auto text-white-10">
    <p class=" fs-6 fw-bold" >En caso de que el nombre mostrado no corresponda al suyo o identifique algún error, le solicitamos amablemente que se comunique con nuestro equipo de soporte a la brevedad. Estaremos encantados de asistirle para resolver cualquier inconveniente.</p>
    <p class="fw-bold"><a  style="color:var(--primary-color);" routerLink="/" >MediLink</a></p>
  </footer>
</div>



<app-notifications/>
